module.exports = __webpack_public_path__ + "static/media/ic-parcerias.0e8a45ef.svg";